module.exports = __webpack_public_path__ + "static/media/arrows-towards-center.3aaf3b02.svg";